<template>
	<button class="global-language-select" :class="{ 'global-language-select--big': big }">
		<ClientOnly>
			<template #fallback>
				<div class="global-language-select__activator">
					<div class="global-language-select__country">
						<div class="global-language-select__country-flag-wrapper">
							<GlobalIcon
								class="global-language-select__country-icon"
								:name="getCountryFlagIconName(locale)"
								prefix="country"
								:height="24"
								:width="24" />
						</div>
						<div v-if="big" class="global-language-select__country-text">{{ locale?.toUpperCase() }}</div>
					</div>
					<GlobalIcon name="arrow-down" :height="16" class="global-language-select__select-icon" />
				</div>
			</template>
			<v-menu attach class="global-language-select__menu" :class="{ 'global-language-select__menu--big': big }" scroll-strategy="close">
				<template #activator="{ props }">
					<div class="global-language-select__activator" v-bind="props">
						<div class="global-language-select__country">
							<div class="global-language-select__country-flag-wrapper">
								<!-- <Icon class="global-language-select__country-icon" :name="getCountryFlagIconName(locale)" /> -->
								<GlobalIcon
									class="global-language-select__country-icon"
									:name="getCountryFlagIconName(locale)"
									prefix="country"
									:height="24"
									:width="24" />
							</div>
							<div v-if="big" class="global-language-select__country-text">{{ fullName(locale?.toUpperCase()) }}</div>
						</div>
						<GlobalIcon name="arrow-down" :height="16" class="global-language-select__select-icon" />
					</div>
				</template>
				<v-list>
					<v-list-item v-for="item in locales" :key="item.code" :value="item.code" @click="changeLang(item.code)">
						<v-list-item-title>
							<div class="global-language-select__item">
								<div class="global-language-select__country-flag-wrapper">
									<GlobalIcon
										class="global-language-select__country-icon"
										:name="getCountryFlagIconName(item.name)"
										prefix="country"
										:height="24"
										:width="24" />
								</div>
								<div v-if="big" class="global-language-select__item-name global-language-select__item-name--big">
									{{ fullName(item.name) }}
								</div>
								<div v-else class="global-language-select__item-name">
									{{ item.name }}
								</div>
							</div>
						</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</ClientOnly>
	</button>
</template>

<script setup lang="ts">
const { locale, locales } = useI18n()
const i18nService = usei18nService()
const locationRedirectStore = useLocationRedirectStore()
const route = useRoute()
const $t = useI18n().t

defineProps<{
	big?: boolean
}>()

const countryFlag = (c: string) => {
	if (c.toLowerCase() === 'en') return 'gb'
	const country = AllCountryIsoNames.find((country) => country['alpha-2'].toLowerCase() === c.toLowerCase())
	return country ? country['alpha-2'].toLowerCase() : ''
}

const fullName = (c: string) => {
	const country = CountryIsoNamesLanguagePack.find((country) => country.languageCode.toLowerCase() === c.toLowerCase())
	return country ? $t(`components.language_select.language.${country.language?.toLowerCase()}`) : ''
}

const getCountryFlagIconName = (locale: string) => {
	return `${locale?.toLowerCase() !== 'cs' ? countryFlag(locale?.toLowerCase()) : 'cz'}`
}

const changeLang = (code: string) => {
	if (route.name?.toString().includes('car-rental-urlSlug')) {
		locationRedirectStore.setRedirectLang(code)
		return
	}
	i18nService.changeLang(code)
}
</script>

<style lang="scss">
@import './LanguageSelect.scss';
</style>
